<ab-advanced-searchbox
  [availableParams]="availableParams"
  [selectedParams]="selectedParams"
  [searchQuery]="searchQuery"
  [showUpgradeCtaAdvancedSearch]="showUpgradeCta.advancedSearch"
  [showUpgradeCtaCustomFilters]="showUpgradeCta.customFilters"
  [showCustomFiltersLink]="showCustomFiltersLink"
></ab-advanced-searchbox>
